"use client"
import React, { ComponentPropsWithRef } from "react"
import { Check, Error, IconProps } from "../../icons"
import { classNames } from "../../utils"
import { AvatarProps } from "../Avatar"
import { FlexProps } from "../Flex"
import {
  Item,
  ItemAction,
  ItemAvatar,
  ItemContent,
  ItemDescription,
  ItemSide,
  ItemTitle,
} from "../Item"

/**
 * A succinct message that is displayed temporarily.
 */

export type ToastProps = FlexProps

const ToastBase = ({ className, ...props }: ToastProps) => {
  return (
    <Item
      className={classNames("gap-4 px-4 py-3", className)}
      variant="unstyled"
      {...props}
    />
  )
}

const ToastAvatar = ({ size = 44, className, ...props }: AvatarProps) => {
  return (
    <ItemAvatar
      className={classNames("rounded", className)}
      size={size}
      {...props}
    />
  )
}

const ToastContent = ItemContent

const ToastTitle = ItemTitle

const ToastDescription = ItemDescription

const ToastSide = ({
  className,
  ...props
}: ComponentPropsWithRef<typeof ItemSide>) => {
  return <ItemSide className={classNames("ml-2", className)} {...props} />
}

const ToastAction = ItemAction

export const ToastSuccessIcon = (props: IconProps) => {
  return <Check fill="success" size={24} {...props} />
}

export const ToastErrorIcon = (props: IconProps) => {
  return <Error fill="error" size={24} {...props} />
}

export const Toast = Object.assign(ToastBase, {
  Avatar: ToastAvatar,
  Content: ToastContent,
  Title: ToastTitle,
  Description: ToastDescription,
  Side: ToastSide,
  Action: ToastAction,
  SuccessIcon: ToastSuccessIcon,
  ErrorIcon: ToastErrorIcon,
})
